type Listener = () => void;

let version = 0;
const listeners = new Set<Listener>();

/** Notify all history UIs (nav + sidebar) to refetch threads. */
export function invalidateMcpThreadHistory(): void {
  version += 1;
  listeners.forEach(listener => listener());
  void import('../api/mcpApi').then(mod => {
    void mod.invalidateMcpApiThreadTags();
  });
}

export function subscribeMcpThreadHistory(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getMcpThreadHistoryVersion(): number {
  return version;
}
